export const ApplicationMetricsContextStates = {
    DEFAULT_PAGE: 'DEFAULT_PAGE',
};
//# sourceMappingURL=application-metrics-context-states.js.map